import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import { getToken } from '@/utils/auth' // getToken from cookie
// import permission from './views/permission/permission'
import { routesModule } from '@/router'

NProgress.configure({ showSpinner: false })// NProgress Configuration

// permission judge function
function hasPermission(roles, permissionRoles) {
  if (roles.indexOf('admin') >= 0) return true // admin permission passed directly
  if (!permissionRoles) return true
  return roles.some(role => permissionRoles.indexOf(role) >= 0)
}

const whiteList = ['/login', '/authredirect','/scanTheQRCodeToSignIn','/signSuccess']// no redirect whitelist
function saveObjArr(name, data) { //localStorage 存储数组对象的方法
  localStorage.setItem(name, JSON.stringify(data))
}
function getObjArr(name) { //localStorage 获取数组对象的方法
  return JSON.parse(window.localStorage.getItem(name));
}
let getRouter //用来获取后台拿到的路由

router.beforeEach((to, from, next) => {
  //console.log(router)
  NProgress.start() // start progress bar
  // if(to.meta.requireAuth){
    if (getToken()) { // determine if there has token
      /* has token*/
      if(store.getters.roletype == 2){
        window.location.href="/dashboard/index"
      }else{
        if (to.path === '/login' || to.path === '/tianwayun') {
          // next('/')
          if(to.path === '/login'){
            next({to, replace: true })
            // NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
          }else {
            next({to, replace: true })
            // NProgress.done()
          }

        } else {
          if (store.getters.roles.length === 0) { // 判断当前用户是否已拉取完user_info信息
            let routesList = []
            // store.dispatch('selectUserBindRoleByUserId').then(res => {
            //   let jsonBodyData = res.jsonBody
            //   let codes = jsonBodyData.msgBody.codes
            //   //console.log(codes)
            // })

            if (!getRouter) {//不加这个判断，路由会陷入死循环
              if(!getObjArr('router')){
                //console.log(store.getters.roletype  +"++++roletype")
                if(store.getters.roletype == 2 || store.getters.roletype == 3){
                  let V3_0_OrgChildManage = {
                    path: '',
                    component: 'Layout',
                    children: [{
                      path: 'organizationMge',
                      component: '/organizationMge/index',
                      name: 'organizationMge',
                      meta: { title: 'organizationMge', icon: 'groups', noCache: true},
                      setName:'V3_0_OrganizationManage'
                    }]
                  }
                  routesList.push(V3_0_OrgChildManage)
                  saveObjArr('router', routesList) //存储路由到localStorage
                  store.dispatch('GenerateRoutes', { routesList }).then(() => {
                    router.addRoutes(store.getters.addRouters)
                  })
                  next({to, replace: true })
                }else {
                  store.dispatch('selectUserBindRoleByUserId').then(res => {
                    let jsonBodyData = res.jsonBody
                    let codes = jsonBodyData.msgBody.codes
                    //console.log(store.getters.roletype  +"++++roletype2")
                    routesModule.forEach(function (v,i) {
                      let newItemData = JSON.parse(JSON.stringify(v))

                      newItemData.routes.children = []
                      let isAdd = false
                      // if(store.getters.roletype == 2 || store.getters.roletype == 3){
                      //   if(v.name == "V3_0_OrgChildManage" || v.name == "V3_0_OrganizationManage"){
                      //
                      //   }
                      // }else {
                      if(v.name == "V3_0_DeviceManage" || v.name == "V3_0_UserManage" || v.name == "V3_0_OrganizationManage" || v.name == "V3_0_OrgChildManage" || v.name == "V3_0_CloudSpaceManage"){
                        if(v.name == "V3_0_OrganizationManage"){
                          if(store.getters.roletype == 1 || store.getters.roletype == 0){
                            if(codes.indexOf(v.name) >= 0){
                              isAdd = true
                            }
                          }else {
                            return false
                          }
                        }else if(v.name == "V3_0_OrgChildManage"){
                          if(store.getters.roletype == 1 || store.getters.roletype == 0){
                            return false
                          }else {
                            if(codes.indexOf(v.name) >= 0){
                              isAdd = true
                            }
                          }
                        }else {
                          let isJudgment = stringJudgmentName(codes,v.name)
                          if(isJudgment){
                            isAdd = true
                          }
                        }
                      }else {
                        if(v.name == "V3_0_AuthorityMge" || v.name == "V3_0_IQManageCenter_MediaDeviceManage" || v.name == "V3_0_IQManageCenter_Setting"){
                          if(store.getters.roletype == 1){
                            isAdd = true
                          }else {
                            isAdd = false
                          }
                        }else {
                          // return false
                          isAdd = true
                        }
                      }
                      // }
                      //console.log(v.name)
                      //console.log(isAdd)
                      if((v.routes.children.length > 0) && (isAdd)){
                        let childrenData = v.routes.children
                        isAdd = recursiveChildren(childrenData,codes,newItemData.routes)
                      }
                      if (isAdd){
                        if(store.state.user.userStatus == 1 && (newItemData.name == 'V3_0_OrganizationManage')){

                        }else {
                          routesList.push(newItemData.routes)
                        }

                      }
                    })
                    saveObjArr('router', routesList) //存储路由到localStorage
                    store.dispatch('GenerateRoutes', { routesList }).then(() => {
                      router.addRoutes(store.getters.addRouters)
                    })
                    next({to, replace: true })

                  })
                }

              }else {
                routesList = getObjArr('router')//拿到路由
                getRouter = getObjArr('router')//拿到路由
                let roleRouter = getObjArr('router')
                store.dispatch('GenerateRoutes', {  routesList }).then(() => {
                  router.addRoutes(store.getters.addRouters)
                })
                next({to, replace: true })
              }
              // store.dispatch('GenerateRoutes', {  routesList }).then(() => {
              //   router.addRoutes(store.getters.addRouters)
              // })
              // next({to, replace: true })
            }else {
              next()
            }


            // store.dispatch('GetUserInfo').then(res => { // 拉取user_info
            //   const roles = res.data.roles // note: roles must be a array! such as: ['editor','develop']
            //   store.dispatch('GenerateRoutes', { roles }).then(() => { // 根据roles权限生成可访问的路由表
            //     router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
            //     next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
            //   })
            // }).catch((err) => {
            //   store.dispatch('FedLogOut').then(() => {
            //     Message.error(err || 'Verification failed, please login again')
            //     next({ path: '/' })
            //   })
            // })
          } else {
            // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
            if (hasPermission(store.getters.roles, to.meta.roles)) {
              next()//
            } else {
              next({ path: '/401', replace: true, query: { noGoBack: true }})
            }
            // 可删 ↑
          }
        }
      }

    } else {
      /* has no token*/
      if(to.path === '/tianwayun'){
        next()
        NProgress.done()
      }else if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
        next()
      } else {
        // next('/login') // 否则全部重定向到登录页
        // NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
        if(to.path == '/privacy'){
          next()
        }else {
          next('/login') // 否则全部重定向到登录页
          NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
        }
      }

    }
  // }else {
  //   next()
  // }

})

function stringJudgmentName(codes, vName) {
  let codesData = codes.length
  let result = false
  for(let i = 0; i < codesData; i++){
    let itmeCodes = codes[i]
    if(itmeCodes.indexOf(vName) >= 0){
      result = true
      break
    }
  }
  return result
  // codesData.forEach(function (item,index) {
  //   item.includes
  // })
}

function recursiveChildren(childrenData,codes, routes) {
  let result = false
  childrenData.forEach(function (item, index) {
    // let setNameType = stringJudgmentName (codes,item.setName)
    // if(setNameType){
    //   routes.children.push(item)
    //   result = true
    // }
    // if(codes.indexOf(item.setName) >= 0){
    //   routes.children.push(item)
    //   result = true
    // }
    if(item.setName == "V3_0_DeviceManage_RepairLog"){
      let setNameType = stringJudgmentName (codes,item.setName)
      if(setNameType){
        routes.children.push(item)
        result = true
      }
    }else {
      routes.children.push(item)
      result = true
    }


    if(item.children != undefined){
      if(item.children.length > 1){
        result = recursiveChildren(item.children,codes,routes.routes)
      }
    }
  })
  return result
}

router.afterEach(() => {
  NProgress.done() // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js